import { IConfig } from '@cian/config/shared';
import { createSelector } from '@reduxjs/toolkit';
import { selectIsDailyRentOtaConversionExperimentEnabled } from 'shared/selectors/experiments';
import { selectOnlineBooking } from 'shared/selectors/jsonQuery';

export const selectOnlineBookingFilter = (config: IConfig) => {
  const isOtaConversionExperimentSelector = selectIsDailyRentOtaConversionExperimentEnabled(config);

  return createSelector(
    [selectOnlineBooking, isOtaConversionExperimentSelector],
    (value, isOtaConversionExperimentActive) => ({
      label: 'Формат бронирования',
      value: Boolean(value),
      visible:
        Boolean(config.get<boolean>('dailyrent.onlineBookingFilterDesktop.Enabled')) &&
        !isOtaConversionExperimentActive,
    }),
  );
};
